module.exports = __webpack_public_path__ + "img/wild.177c347a.png";